import clsx from "clsx";
import SpanEvent from "layout/SpanEvent";
import React, {
  FC,
  ChangeEvent,
  FocusEvent,
  KeyboardEvent,
  RefObject,
  useState,
} from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

interface InputTextFieldProps {
  type: string;
  placeholder: string;
  id: string;
  name: string;
  label?: string;
  isDisable?: boolean;
  isAutoFocus?: boolean;
  value: string;
  size?: "sm" | "md" | "lg";
  onChange?: (event: ChangeEvent<any>) => void;
  onBlur?: (event: FocusEvent<any>) => void;
  onKeyDown?: (event: KeyboardEvent<any>) => void;
  error?: boolean;
  helperText?: string | boolean;
  isvalid?: any;
  variant?: string;
  labelClass?: string;
  ref?: RefObject<HTMLInputElement>;
  forwardedRef?: RefObject<HTMLInputElement>;
  passwordVisible?: boolean;
  isSolidField?: boolean;
}

const InputTextField: FC<InputTextFieldProps> = (
  {
    type,
    placeholder,
    id,
    label,
    size = "md",
    isAutoFocus = false,
    error,
    isDisable = false,
    helperText,
    variant = "outline",
    labelClass = " ",
    passwordVisible = false,
    isSolidField = false,
    ...rest
  },
  ref
) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  let borderClass = "";

  if (isDisable) {
    borderClass = "border-0";
  } else if (error || variant === "outline") {
    borderClass = "border-1";
  } else {
    borderClass = "border-0";
  }

  const inputClass = `form-control  form-control-${size}  ${borderClass} ${
    isSolidField ? "form-control-solid" : "bg-transparent "
  } rounded-5 `;

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <div className="fv-row mb-5 position-relative">
      {label && (
        <label htmlFor={id} className={"form-label fs-6 mb-0 " + labelClass}>
          {label}
        </label>
      )}

      <input
        type={isPasswordVisible ? "text" : type}
        placeholder={placeholder}
        id={id}
        autoFocus={isAutoFocus}
        autoComplete="off"
        className={clsx(`text-gray-900 ${inputClass} `, {
          "border-danger ": error,
        })}
        disabled={isDisable}
        {...rest}
      />
      {passwordVisible && (
        <SpanEvent
          className="position-absolute  end-0 translate-middle-y me-3 cursor-pointer"
          style={{ top: "42px" }}
          onClick={togglePasswordVisibility}
        >
          {isPasswordVisible ? (
            <FaEye className="fs-2  me-1 text-muted" />
          ) : (
            <FaEyeSlash className="fs-2 me-1 text-muted" />
          )}
        </SpanEvent>
      )}
      {error && (
        <div className="fv-plugins-message-container ">
          <div className="fv-help-block">
            <span role="alert">{helperText}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default InputTextField;
